import { PhoneOutlined } from "@ant-design/icons";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Rnd } from "react-rnd";
import { useLocation } from "react-router-dom";

const IframeWidget = () => {
  return;
  const iframeRef = useRef(null);
  const [iframeUrl] = useState("https://ct3.sarv.com/login/m/webplugin/");

  const [open, setOpen] = useState(false);
  const { user } = useSelector(state => state.auth);
  const { pathname } = useLocation();

  const [position, setPosition] = useState({
    x: window.innerWidth - 370,
    y: window.innerHeight - 520,
  });
  const [size, setSize] = useState({ width: 350, height: 500 });

  // ⏳ cookies
  const getCookie = (name) => {
    const cookies = document.cookie.split(";");
    for (let c of cookies) {
      const s = c.trim();
      if (s.startsWith(name + "=")) return s.substring(name.length + 1);
    }
    return null;
  };

  const setCookie = (name, value, days) => {
    const expiry = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = `${name}=${value}; path=/; Secure; SameSite=None; expires=${expiry}`;
  };

  const deleteCookie = (name) => {
    document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; Secure; SameSite=None`;
  };

  // 🔄 Load iframe whenever we open widget
  useEffect(() => {
    if (open && iframeRef.current) {
      iframeRef.current.src = getCookie("curr_url") || iframeUrl;
    }
  }, [open, iframeUrl]);

  // Listen login/logout messages
  useEffect(() => {
    const listener = (event) => {
      const data = event.data;
      if (data.action === "login") {
        setCookie("curr_url", data.url, 1);
      } else if (data.action === "logout") {
        deleteCookie("curr_url");
        if (iframeRef.current) iframeRef.current.src = iframeUrl;
      }
    };
    window.addEventListener("message", listener);
    return () => window.removeEventListener("message", listener);
  }, []);

  // Hide for agency/sign-in page
  if (user?.is_agency || user?.is_supervisor || pathname === "/sign-in") return null;

  return (
    <>
      {/* 🔘 Small circle */}
      {!open && (
        <div
          onClick={() => setOpen(true)}
          style={{
            width: 56,
            height: 56,
            borderRadius: "50%",
            position: "fixed",
            bottom: 24,
            right: 24,
            zIndex: 9999,
            background: "#2e3132",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#fff",
            cursor: "pointer",
            fontSize: 22,
            boxShadow: "0 4px 14px rgba(0,0,0,0.25)",
          }}
        >
          <PhoneOutlined/>
        </div>
      )}

      {/* 🪟 Widget when open */}
      {open && (
        <Rnd
          size={size}
          position={position}
          minWidth={200}
          minHeight={250}
          bounds="window"
          dragHandleClassName="widget-header"
          onDragStop={(e, d) => setPosition({ x: d.x, y: d.y })}
          onResizeStop={(e, direction, ref, delta, pos) => {
            setSize({
              width: parseInt(ref.style.width),
              height: parseInt(ref.style.height),
            });
            setPosition(pos);
          }}
          style={{
            position: "fixed",
            zIndex: 9999,
            borderRadius: 12,
            boxShadow: "0 4px 16px rgba(0,0,0,0.25)",
            overflow: "hidden",
            background: "white",
          }}
        >
          {/* 🔹 Header */}
          <div
            className="widget-header"
            style={{
              height: 32,
              background: "rgba(0,0,0,0.7)",
              color: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "0 10px",
              cursor: "move",
              userSelect: "none",
              fontSize: 13,
            }}
          >
            <span>↕ Move</span>
            <button
              onClick={() => setOpen(false)}
              style={{
                background: "transparent",
                border: "none",
                color: "#fff",
                cursor: "pointer",
                fontSize: 16,
              }}
            >
              ✕
            </button>
          </div>

          {/* 🔹 Iframe */}
          <iframe
            ref={iframeRef}
            allow="microphone"
            title="CollectEaze Agent"
            style={{
              width: "100%",
              height: "calc(100% - 32px)",
              border: "none",
              background: "white",
            }}
          ></iframe>
        </Rnd>
      )}
    </>
  );
};

export default IframeWidget;
